import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "star"]

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.star)
    this.inputTarget.value = rating
    this.updateStars(rating)
  }

  hover(event) {
    const rating = parseInt(event.currentTarget.dataset.star)
    this.updateStars(rating)
  }

  unhover() {
    const rating = parseInt(this.inputTarget.value) || 0
    this.updateStars(rating)
  }

  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-black")
      } else {
        star.classList.remove("text-black")
        star.classList.add("text-gray-300")
      }
    })
  }
}
